import type { TestOrderInput } from '@/features/patient-record/hooks/useTestOrderMutations';
import type { TestOrderViewModel } from '@/features/patient-record/types';

/**
 * Builds the full PUT body for an order the user is changing from outside
 * the edit dialog (cancel, a status change, recording a result). The PUT
 * replaces the whole record, so every field is copied off the current view
 * model and only `overrides` differ.
 */
export function toTestOrderInput(
  order: TestOrderViewModel,
  overrides: Partial<TestOrderInput> = {},
): TestOrderInput {
  return {
    testName: order.testName,
    testType: order.testType,
    testCode: order.testCode,
    panelName: order.panelName,
    labProvider: order.labProvider,
    indication: order.indication,
    orderedByExternal: order.orderedByExternal,
    orderedDate: order.orderedDate,
    sampleType: order.sampleType,
    sampleCollectedDate: order.sampleCollectedDate,
    sampleSentDate: order.sampleSentDate,
    targetDeliveryDate: order.targetDeliveryDate,
    specimen: order.specimen,
    status: order.status,
    resultDate: order.resultDate,
    resultSummary: order.resultSummary,
    externalReportUrl: order.externalReportUrl,
    notes: order.notes,
    ...overrides,
  };
}
